export default {
	ALERT_IN: "application-alert-show",
	ALERT_OUT: "application-alert-hide",
	TOGGLE_AUTH_POPUP: "application-auth-popup-toggle",
	SET_STATIC_WARNING: "application-static-warning-set",
	CLEAR_STATIC_WARNING: "application-static-warning-clear",
};
